var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon && _vm.color)?_c('v-chip',{attrs:{"color":_vm.color,"label":"","dark":"","title":_vm.hint,"small":""}},[_c('v-icon',{attrs:{"small":"","left":!!_vm.text}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.text)+" ")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }